import { ArrayParam, NumberParam, NumericArrayParam, StringParam, withDefault } from 'use-query-params';

export const queryKeys = {
  OFFER: 'realtor-offer'
};

export const statusColors = {
  ACTIVE: 'bg-success-50 text-success-500',
  OUTWORN: 'bg-warning-50 text-warning-500',
  CREATED: 'bg-progress-50 text-progress-500',
  CANCELED: 'bg-error-50 text-error-500',
  CLOSED: 'bg-success-100 text-success-800'
};

export const offerPaymentTypes = ['STATIC', 'PREPAYMENT_N_PERCENT', 'TOTAL_AMOUNT_N_PERCENT', 'PER_ARE'];

export const initialCreateOrUpdateOfferState = {
  name: '',
  visible: false,
  isDirtyHouseOrBuilding: false,
  paymentType: {
    type: 'PREPAYMENT_N_PERCENT'
  },
  filter: {
    houses: [],
    buildings: []
  },
  flatIds: [],
  realtors: [0],
  totalElements: 0
};

export const offerQueryParams = {
  search: StringParam,
  page: withDefault(NumberParam, 1),
  size: withDefault(NumberParam, 10),
  startDate: StringParam,
  finishDate: StringParam,
  realtors: NumericArrayParam,
  houses: NumericArrayParam,
  status: StringParam,
  buildings: NumericArrayParam,
  actions: ArrayParam,
  companies: ArrayParam
};

export const offerName: Record<string, string> = {
  uz: 'Taklif',
  ru: 'Предложение',
  en: 'Offer',
  tr: 'Teklif',
  tj: 'Пешниҳод',
  ky: 'Сунуш'
};
